var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: _vm.cls },
    [
      this.$slots.avatar
        ? [_c("div", { class: _vm.cls + "-avatar" }, [_vm._t("avatar")], 2)]
        : _vm._e(),
      _vm.showContent
        ? [
            _c("div", { class: _vm.cls + "-content" }, [
              _vm.title || this.$slots.title
                ? _c(
                    "h4",
                    { class: _vm.cls + "-title" },
                    [
                      _vm.title
                        ? [_vm._v(" " + _vm._s(_vm.title) + " ")]
                        : [_vm._t("title")],
                    ],
                    2
                  )
                : _vm._e(),
              _vm.description || this.$slots.description
                ? _c(
                    "div",
                    { class: _vm.cls + "-description" },
                    [
                      _vm.description
                        ? [_vm._v(" " + _vm._s(_vm.description) + " ")]
                        : [_vm._t("description")],
                    ],
                    2
                  )
                : _vm._e(),
            ]),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }